import React, { Component } from 'react';

import classes from './ModalScroll.module.css';
import Backdrop from '../Backdrop/Backdrop';
import Navbar from '../../Navigation/Navbar/Navbar';
import AppComponentContext from '../../../contexts/AppComponentContext';

export default class ModalScroll extends Component {
  render () {
    let navbar = null;
    if (this.props.navbarLeftElement !== null || this.props.navbarCenterElement !== null || this.props.navbarRightElement !== null) {
      navbar = (
        <div className={classes.Navbar} style={this.props.modalScrollNavbarWrapperStyle}>
          <Navbar round left={this.props.navbarLeftElement} center={this.props.navbarCenterElement} right={this.props.navbarRightElement} fromModal />
        </div>
);
    }
    let modalScrollCss = this.props.collapsible ? [classes.ModalScroll, classes.ModalScrollCollapsible].join(' ') : classes.ModalScroll;
    return (
      <AppComponentContext.Consumer>{appContext => (
        <div className={appContext.loggedIn ? classes.ModalScrollWrapper : classes.ModalScrollWrapperFixed} style={this.props.modalScrollWrapperStyle}>
          {appContext.isLandscape ? <Backdrop /> : ''}
          <div className={modalScrollCss} style={this.props.modalScrollStyle}>
            {navbar}
            <div className={classes.Children} style={this.props.modalScrollChildrenStyle}>
              {this.props.children}
            </div>
            <div className={classes.Bottom} style={this.props.modalBottomStyle} />
          </div>
        </div>
      )}
      </AppComponentContext.Consumer>
    );
  }
}
ModalScroll.propTypes = {};
ModalScroll.defaultProps = {
  navbarLeftElement: null,
  navbarCenterElement: null,
  navbarRightElement: null,
  modalScrollWrapperStyle: {},
  modalScrollStyle: {},
  modalScrollNavbarWrapperStyle: {},
  modalScrollChildrenStyle: {},
  modalBottomStyle: {}
};



// WEBPACK FOOTER //
// ./src/components/UI/ModalScroll/ModalScroll.js